import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { View } from '../../react-native-components';
import HighChartPie from '../../HighCharts/HighChartsPie';
import { getPieChartDefaultData } from '../../../../containers/Overview/constants';
import { handleHighChartsExport } from '../../../../containers/Overview/utils';

const PieChartContainer = forwardRef((props, ref) => {
  const { options = {}, tooltipComponent, value, isLowSampleSize, onChartClick, data } = props;

  // const chartRef = useRef(null);

  // const actionButtonClick = e => {
  //   handleHighChartsExport(e, chartRef, data);
  // };

  // useImperativeHandle(ref, () => ({
  //   actionButtonClick
  // }));

  return (
    <View style={{ alignItems: 'center' }}>
      <HighChartPie
        isLowSampleSize={isLowSampleSize}
        tooltipComponent={tooltipComponent}
        onChartClick={onChartClick}
        defaultOption={getPieChartDefaultData()}
        options={options}
        value={value}
        style={{ container: { width: 180, height: 280 } }}
        ref={ref}
      />
    </View>
  );
});

export default PieChartContainer;
